import { Injectable } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormArray, AbstractControl, ValidationErrors } from '@angular/forms';
import { FormService } from '@spartacus/organization/administration/components';
import { CustomFormValidators } from '@spartacus/storefront';
import { days } from '../uig-branches/uig-branches';
import { BranchForm, StoreLocatorFeatureGroup } from '../uig-branches/uig-branches.models';

@Injectable({
  providedIn: 'root',
})
export class UigBranchFormService extends FormService<BranchForm> {

  storeFeatures: StoreLocatorFeatureGroup[];
  static TIME_PATTERN = /^(2[0-3]|[01]?[0-9]):([0-5]?[0-9])$/;

  protected build() {
    const form = new UntypedFormGroup({});
    form.setControl('name', new UntypedFormControl('', Validators.required));
    form.setControl('headOffice', new UntypedFormControl(false));
    form.setControl('ownerOrManager', new UntypedFormControl(''));
    form.setControl('contactPerson', new UntypedFormControl(''));
    form.setControl('streetAndHouseNo', new UntypedFormControl(''));
    form.setControl('countryCode', new UntypedFormControl(''));
    form.setControl('postalCode', new UntypedFormControl(''));
    form.setControl('place', new UntypedFormControl(''));
    form.setControl('phone', new UntypedFormControl(''));
    form.setControl('fax', new UntypedFormControl(''));
    form.setControl('email', new UntypedFormControl('', CustomFormValidators.emailValidator));
    form.setControl('website', new UntypedFormControl(''));
    form.setControl('onlineShop', new UntypedFormControl(false));
    for (let i = 0; i < days.length; i++) {
      form.setControl(days[i] + 'MorningFrom', new UntypedFormControl('', UigBranchFormService.validateTime));
      form.setControl(days[i] + 'MorningTo', new UntypedFormControl('', UigBranchFormService.validateTime));
      form.setControl(days[i] + 'AfternoonFrom', new UntypedFormControl('', UigBranchFormService.validateTime));
      form.setControl(days[i] + 'AfternoonTo', new UntypedFormControl('', UigBranchFormService.validateTime));
    }
    form.setControl('features', new UntypedFormArray([]));
    if (this.storeFeatures) {
      for (let i = 0; i < this.storeFeatures.length; i++) {
        let featuresMap = this.storeFeatures[i].features;
        for (let featureKey of Object.keys(featuresMap)) {
          (form.get('features') as UntypedFormArray).push(new UntypedFormControl(featureKey));
        }
      }
    }
    form.setControl('branchId', new UntypedFormControl('', Validators.required));
    form.setControl('branchVat', new UntypedFormControl(''));
    form.setControl('branchType', new UntypedFormControl(''));
    form.setControl('branchSearchExport', new UntypedFormControl(''));
    form.setControl('branchVendorReporting', new UntypedFormControl(''));

    this.form = form;
  }

  protected patchData(item: BranchForm) {
    super.patchData(item);
  }

  getForm(item?: BranchForm, features?: StoreLocatorFeatureGroup[]): UntypedFormGroup {
    this.storeFeatures = features;
    if (this.form && !!item) {
      this.patchData(item);
      return this.form;
    }

    if (!this.form) {
      this.build();
    }

    // while we should be able to reset with initial value, this doesn't always work
    // hence, we're patching afterwards.
    this.form.reset();

    this.form.enable();
    this.patchData(item);
    return this.form;
  }

  static validateTime(control: AbstractControl): ValidationErrors | null {
    const time = control.value as string;
    return time && (time.match(UigBranchFormService.TIME_PATTERN))
      ? null
      : { invalidTime: true };
  }
}